import { render } from "./TermsOfService.vue?vue&type=template&id=db869ee8&scoped=true"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=db869ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db869ee8"]])

export default __exports__